import {
  faKey,
  faPen,
  faRotateRight,
  faTrashAlt
} from '@fortawesome/pro-light-svg-icons';
import type { GridColDef } from '@mui/x-data-grid';

import { PERMISSIONS } from '@/constants/auth.constants';

import {
  renderActiveCell,
  renderInternalCell,
  renderLastSignInCell,
  renderOrganizationCountCell,
  renderRolesCell,
  renderUpdatedAtCell,
  renderUserTypeCell
} from './Users.renderers';
import type { User } from './Users.types';

export const EMPTY_USER: User = {
  id: -1,
  name: '',
  email: '',
  roles: [],
  organizations: [],
  created_at: '',
  updated_at: '',
  active: false,
  internal: false,
  is_service_account: false,
  // -----New Fields to get rid of type error
  notification_ticket_service: false,
  notification_ticket_threat: false,
  notification_announcement: false,
  notification_threat_priority: [],
  notification_tags: [],
  notification_ticket_event: [],
  notification_report_email: true,
  notification_report_attachment: true,
  organization_count: 0,
  sms_consent: false,
  tos_consent: false
};

export const RESTRICTED_USERS = [
  'socticketwatcher@pondurance.com',
  'socnotification@pondurance.com',
  'scope_soc@pondurance.com',
  'app-dev@pondurance.com'
];

export const USERS_TABLE_COLUMNS: GridColDef[] = [
  { field: 'name', headerName: 'Name', flex: 1, minWidth: 200 },
  { field: 'email', headerName: 'Email', flex: 2, minWidth: 250 },
  {
    field: 'is_service_account',
    headerName: 'Type',
    minWidth: 150,
    align: 'center',
    renderCell: renderUserTypeCell
  },
  {
    field: 'roles',
    headerName: 'Roles',
    flex: 2,
    minWidth: 200,
    renderCell: renderRolesCell
  },
  {
    field: 'organization_count',
    headerName: 'Organizations',
    minWidth: 150,
    align: 'center',
    type: 'boolean',
    renderCell: renderOrganizationCountCell
  },
  {
    field: 'updated_at',
    headerName: 'Last updated',
    minWidth: 160,
    flex: 1,
    renderCell: renderUpdatedAtCell
  },
  {
    field: 'last_sign_in_at',
    headerName: 'Last Sign In',
    minWidth: 160,
    flex: 1,
    renderCell: renderLastSignInCell
  },
  {
    field: 'internal',
    headerName: 'Internal',
    minWidth: 100,
    align: 'center',
    type: 'boolean',
    renderCell: renderInternalCell
  },
  {
    field: 'active',
    headerName: 'Active',
    minWidth: 100,
    type: 'boolean',
    renderCell: renderActiveCell
  },
  {
    field: 'action',
    headerName: '',
    width: 80,
    type: 'actions'
  }
];

export const USER_CONTEXT_MENU_LIST = [
  {
    label: 'Edit',
    icon: faPen,
    permission: PERMISSIONS.USERS_UPDATE
  },
  {
    label: 'Manage API Keys',
    icon: faKey,
    permission: PERMISSIONS.ADMIN_UPDATE
  },
  {
    label: 'Reset MFA',
    icon: faRotateRight,
    permission: PERMISSIONS.USERS_UPDATE
  },
  {
    label: 'Delete',
    icon: faTrashAlt,
    permission: PERMISSIONS.USERS_DELETE
  }
];

export default USERS_TABLE_COLUMNS;
